// extracted by mini-css-extract-plugin
export default {"tagInputContainer":"ExpertiseFormStep_tagInputContainer__oHjCh","tagContainer":"ExpertiseFormStep_tagContainer__ZNrJ6","tag":"ExpertiseFormStep_tag__JeMKT"};